import { Alert, AlertDescription, AlertTitle } from '@vivicta/ui';
import { ExternalLink } from 'lucide-react';
import { describeSignInError } from './signInError';

export const SignInErrorAlert = ({ error }: { error: unknown }) => {
  const { icon: Icon, severity, title, description, action } =
    describeSignInError(error);

  return (
    <Alert variant={severity} className="mt-6">
      <Icon aria-hidden="true" className="h-4 w-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="mt-1.5 space-y-3 text-muted-foreground">
        <p className="leading-relaxed">{description}</p>

        {action && (
          <a
            href={action.href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground underline underline-offset-4 hover:no-underline"
          >
            {action.label}
            <ExternalLink aria-hidden="true" className="h-3 w-3" />
          </a>
        )}
      </AlertDescription>
    </Alert>
  );
};
